<template>
    <div class="p-4">
        <div class="btn-home col-md-12 mt-3 mb-4 d-flex justify-content-end">
            <button type="button" class="btn btn-outline-main" @click="$emit('returnHome')">
                <i class="fas fa-arrow-left"></i> Volver
            </button>
            <h4 class="m-0 text-center flex-grow-1">Emitir Comprobante</h4>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="card mb-4">
                    <div class="card-header text-white bg-main">
                        <strong>Datos del comprobante</strong>
                    </div>
                    <div class="card-body">
                        <div class="row g-3 align-items-end">
                            <div class="col-md-12">
                                <label class="form-label d-block">Tipo de comprobante</label>
                                <div class="doc-toggle">
                                    <label class="doc-toggle__option"
                                        :class="{ 'doc-toggle__option--active': comprobante.tipo == 'boleta' }">
                                        <input type="radio" value="boleta" v-model="comprobante.tipo"
                                            @change="mtdChangeTipo" />
                                        <i class="fas fa-id-card"></i>
                                        <span>Boleta</span>
                                    </label>
                                    <label class="doc-toggle__option"
                                        :class="{ 'doc-toggle__option--active': comprobante.tipo == 'factura' }">
                                        <input type="radio" value="factura" v-model="comprobante.tipo"
                                            @change="mtdChangeTipo" />
                                        <i class="fas fa-building"></i>
                                        <span>Factura</span>
                                    </label>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <label class="form-label">Fecha de emisión</label>
                                <input type="date" class="form-control form-control-sm" v-model="comprobante.date" />
                            </div>

                            <div class="col-md-12">
                                <label class="form-label">{{ comprobante.tipo == "factura" ? "RUC" : "DNI" }}</label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm" v-model="client.document"
                                        @keypress="isNumber" @keypress.enter="mtdSearchDocument"
                                        :maxlength="comprobante.tipo == 'factura' ? 11 : 8"
                                        :placeholder="comprobante.tipo == 'factura' ? 'N° de RUC' : 'N° de DNI'" />
                                    <button class="btn btn-bm" type="button" @click="mtdSearchDocument">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <label class="form-label">
                                    {{ comprobante.tipo == "factura" ? "Razón Social" : "Nombres y Apellidos" }}
                                </label>
                                <input type="text" class="form-control form-control-sm w-100" v-model="client.name"
                                    :disabled="disabledClient" :placeholder="comprobante.tipo == 'factura'
                                        ? 'Razón social del proveedor'
                                        : 'Nombres y apellidos del cliente'
                                        " />
                            </div>

                            <div class="col-md-12" v-if="comprobante.tipo == 'factura'">
                                <label class="form-label">Dirección fiscal</label>
                                <input type="text" class="form-control form-control-sm" v-model="client.address"
                                    placeholder="Dirección fiscal del proveedor" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-9">
                <div class="card mb-4">
                    <div class="card-header text-white bg-main">
                        <strong>Carrito de ítems</strong>
                    </div>
                    <div class="card-body">
                        <div class="row g-2 align-items-end mb-3">
                            <div class="col-md-2">
                                <label class="form-label">Tipo</label>
                                <select class="form-control form-control-sm" v-model="newItem.type">
                                    <option value="unidad">Unidad</option>
                                    <option value="servicio">Servicio</option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label">Descripción</label>
                                <input type="text" class="form-control form-control-sm" v-model="newItem.description"
                                    @keypress.enter="mtdAddItem" placeholder="Descripción del ítem" />
                            </div>
                            <div class="col-md-2">
                                <label class="form-label">Cantidad</label>
                                <input type="text" class="form-control form-control-sm" v-model="newItem.quantity"
                                    @keypress="isNumber" placeholder="0" />
                            </div>
                            <div class="col-md-2">
                                <label class="form-label">Precio</label>
                                <input type="text" class="form-control form-control-sm" v-model="newItem.price"
                                    @keypress="isDecimal" placeholder="0.00" />
                            </div>
                            
                            <div class="col-md-2 d-grid">
                                <button type="button" class="btn btn-sm btn-info" @click="mtdAddItem">
                                    <i class="fas fa-plus"></i> Agregar
                                </button>
                            </div>
                        </div>

                        <div class="table-responsive">
                            <table class="table table-sm table-bordered border-main align-middle text-center">
                                <caption class="py-0 my-0"></caption>
                                <thead class="bg-main text-white">
                                    <tr>
                                        <th scope="col">N°</th>
                                        <th scope="col">Descripción</th>
                                        <th scope="col">Tipo</th>
                                        <th scope="col">Cantidad</th>
                                        <th scope="col">P. Unit</th>
                                        <th scope="col">Subtotal</th>
                                        <th scope="col">Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="items.length == 0">
                                        <td colspan="7">No hay ítems agregados</td>
                                    </tr>
                                    <tr v-for="(item, index) in items" :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td class="text-start">{{ item.description }}</td>
                                        <td>
                                            <span class="badge"
                                                :class="item.type == 'servicio' ? 'bg-info' : 'bg-secondary'">
                                                {{ item.type == "servicio" ? "SERVICIO" : "UNIDAD" }}
                                            </span>
                                        </td>
                                        <td>{{ item.quantity }}</td>
                                        <td>S/ {{ parseFloat(item.price).toFixed(2) }}</td>
                                        <td>S/ {{ item.subtotal.toFixed(2) }}</td>
                                        <td>
                                            <button type="button" class="btn btn-sm btn-danger"
                                                @click="mtdRemoveItem(index)">
                                                <i class="fas fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="row justify-content-end mt-3">
                            <div class="col-md-4">
                                <div class="d-flex justify-content-between">
                                    <strong>Op. Gravada</strong>
                                    <span>S/ {{ cpSubtotal.toFixed(2) }}</span>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <strong>IGV (18%)</strong>
                                    <span>S/ {{ cpIgv.toFixed(2) }}</span>
                                </div>
                                <hr class="my-1" />
                                <div class="d-flex justify-content-between h5">
                                    <strong>TOTAL</strong>
                                    <strong>S/ {{ cpTotal.toFixed(2) }}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer text-end bg-white">
                        <button type="button" class="btn btn-bm px-4" @click="mtdEmitir">
                            <i class="fas fa-file-invoice"></i>
                            Emitir {{ comprobante.tipo == "factura" ? "Factura" : "Boleta" }}
                        </button>
                    </div>
                </div>
            </div>
        </div>




        <SweetAlert :swal="swal" ref="SweetAlert" />
    </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";

export default {
    name: "c-facturacion-pages-comprobante",
    components: {
        SweetAlert,
    },
    data() {
        return {
            swal: null,
            disabledClient: true,
            comprobante: {
                tipo: "boleta",
                date: moment().format("YYYY-MM-DD"),
            },
            client: {
                document: "",
                name: "",
                address: "",
            },
            newItem: {
                description: "",
                quantity: "",
                price: "",
                type: "unidad",
            },
            items: [],
        };
    },
    computed: {
        cpTotal() {
            return this.items.reduce((acc, item) => acc + item.subtotal, 0);
        },
        cpSubtotal() {
            return this.cpTotal / 1.18;
        },
        cpIgv() {
            return this.cpTotal - this.cpSubtotal;
        },
    },
    methods: {
        ...mapActions(["get", "post"]),
        mtdChangeTipo: function () {
            this.client = { document: "", name: "", address: "" };
            this.disabledClient = true;
        },
        isNumber: function (evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        isDecimal: function (evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        mtdSearchDocument: function () {
            const expected = this.comprobante.tipo == "factura" ? 11 : 8;
            if (this.client.document.length != expected) {
                this.$refs.SweetAlert.showWarning(`Debe ingresar ${expected} dígitos`);
                return;
            }
            this.get({
                url: `${this.$store.getters.get__url}/reniec/${this.client.document}`,
                token: this.$store.getters.get__token,
            })
                .then((response) => {
                    if (response.data.boo == 3) {
                        this.$refs.SweetAlert.showWarning(
                            this.comprobante.tipo == "factura" ? "RUC no encontrado" : "DNI no encontrado"
                        );
                        this.disabledClient = false;
                        this.client.name = "";
                        return;
                    }
                    this.client.name =
                        this.comprobante.tipo == "factura"
                            ? response.data.razon_social
                            : `${response.data.name} ${response.data.last_name}`;
                    this.client.address = response.data.direccion || "";
                    this.disabledClient = false;
                })
                .catch((errors) => {
                    console.log(errors);
                    this.disabledClient = false;
                    this.client.name = "";
                });
        },
        mtdAddItem: function () {
            if (!this.newItem.description) {
                this.$refs.SweetAlert.showWarning("Ingrese una descripción");
                return;
            }
            if (!this.newItem.quantity || parseFloat(this.newItem.quantity) <= 0) {
                this.$refs.SweetAlert.showWarning("Ingrese una cantidad válida");
                return;
            }
            if (this.newItem.price == "" || parseFloat(this.newItem.price) < 0) {
                this.$refs.SweetAlert.showWarning("Ingrese un precio válido");
                return;
            }
            const quantity = parseFloat(this.newItem.quantity);
            const price = parseFloat(this.newItem.price);
            this.items.push({
                description: this.newItem.description,
                quantity,
                price,
                type: this.newItem.type,
                subtotal: quantity * price,
            });
            this.newItem = { description: "", quantity: "", price: "", type: "unidad" };
        },
        mtdRemoveItem: function (index) {
            this.items.splice(index, 1);
        },
        mtdEmitir: function () {
            if (!this.client.document || !this.client.name) {
                this.$refs.SweetAlert.showWarning("Complete los datos del cliente");
                return;
            }
            if (this.items.length == 0) {
                this.$refs.SweetAlert.showWarning("Agregue al menos un ítem al carrito");
                return;
            }
            this.post({
                url: this.$store.getters.get__url + "/Billing/registerComprobante",
                token: this.$store.getters.get__token,
                params: {
                    type: this.comprobante.tipo,
                    type_id: this.comprobante.tipo == "factura" ? 2 : 1,
                    date: this.comprobante.date,
                    client: this.client,
                    items: this.items,
                    subtotal: this.cpSubtotal,
                    igv: this.cpIgv,
                    total: this.cpTotal,
                },
            })
                .then((response) => {
                    if (response.statusCode == 200) {
                        this.$refs.SweetAlert.showSuccess(response.message || "Comprobante emitido correctamente");
                        if (response.data && response.data.pdfTicket) {
                            window.open(response.data.pdfTicket, "_blank");
                        }
                        this.mtdReset();
                    }
                })
                .catch((errors) => {
                    console.log(errors);
                    this.$refs.SweetAlert.showWarning(
                        errors?.response?.data?.message ?? "Ocurrió un error al emitir el comprobante"
                    );
                });
        },
        mtdReset: function () {
            this.client = { document: "", name: "", address: "" };
            this.items = [];
            this.disabledClient = true;
            this.comprobante.date = moment().format("YYYY-MM-DD");
        },
    },
};
</script>

<style lang="scss" scoped>
.bg-main {
    background-color: #8a8a97;
}

.doc-toggle {
    display: inline-flex;
    border: 1px solid #dcdce0;
    border-radius: 50px;
    overflow: hidden;
    background-color: #f5f5f7;
}

.doc-toggle__option {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 18px;
    margin: 0;
    cursor: pointer;
    font-weight: 500;
    color: #8a8a97;
    transition: background-color 0.15s ease, color 0.15s ease;
    user-select: none;
}

.doc-toggle__option input[type="radio"] {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
    pointer-events: none;
}

.doc-toggle__option--active {
    background-color: #900052;
    color: #fff;
}

.doc-toggle__option:not(.doc-toggle__option--active):hover {
    background-color: #eceef1;
}
</style>
